import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { mediaUrl } from "@/lib/api";

const ArticlePage = () => {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => { setA(null); setNf(false); window.scrollTo(0, 0); api.get(`/journal/${slug}`).then((r) => setA(r.data)).catch(() => setNf(true)); }, [slug]);
  if (nf) return <div className="min-h-[60vh] flex items-center justify-center font-serif text-3xl">She's not here.</div>;
  if (!a) return <div className="min-h-[60vh]" />;
  return (
    <article>
      <div className="relative h-[55vh] min-h-[380px] -mt-16 md:-mt-20 flex items-end">
        <img src={mediaUrl(a.cover_image)} alt={a.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-espresso/70 to-espresso/10" />
        <div className="relative max-w-3xl mx-auto w-full px-6 pb-14 text-cream">
          <p className="overline text-gold mb-3">{a.category}</p>
          <h1 className="font-serif text-4xl md:text-6xl leading-none">{a.title}</h1>
        </div>
      </div>
      <div className="max-w-2xl mx-auto px-6 py-16 md:py-24">
        <p className="font-serif text-2xl md:text-3xl leading-relaxed text-espresso/80 mb-10">{a.excerpt}</p>
        <div className="text-espresso/75 leading-loose whitespace-pre-line">{a.body}</div>
        <Link to="/journal" className="inline-block mt-16 text-[0.72rem] tracking-[0.2em] uppercase hover-underline">← All stories</Link>
      </div>
    </article>
  );
};

export default ArticlePage;
